__turbopack_context__.v({
  "container": "ProductBrandAndComparison-module-scss-module__ufjJtq__container",
});
